module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAWCAYAAAHftQ6oAAAAAXNSR0IArs4c6QAAAMFJREFUSA3tk0EKAjEMRX860LN4C/fCnMlDeArB07jyJLNQoTJCM7FJoDDFRelA4fdPkqavBDHGtK73AykhfFeA8ZkmcmpOV1HKoDUl11/uzywxHbbYTfFvLaqC/nxcVU/tgn5uJwlJsNKXkKVf1ZJM8HTHhUzYp2PC7fJSOOhKCGdSPkBzx4zG1YwXL6yOGZkjUlyft97ocEAh/JEqAnnbcNS45k7R7PF39sHpoyFG4YhByAHD9iDEKBwxCDlg2P4ACVEqlErjRdQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/Belgium.png
// module id = 499
// module chunks = 7